import { apiGetContactsCollection } from "./contacts";

export const ADDRESSBOOK_COLLECTION_KEYS = {
  CONTACTS: "contacts",
};

export const ADDRESSBOOK_COLLECTIONS = {
  [ADDRESSBOOK_COLLECTION_KEYS.CONTACTS]: {
    key: ADDRESSBOOK_COLLECTION_KEYS.CONTACTS,
    title: "Contacts",
    description: "Contact collection",
    fetch: apiGetContactsCollection,
    defaultPagination: { page: 1, limit: 25 },
    defaultOrdering: { field: "updatedAt", order: "Desc" },
  },
};

export const resolveAddressbookCollection = (key) => {
  return (
    ADDRESSBOOK_COLLECTIONS[key] ||
    ADDRESSBOOK_COLLECTIONS[ADDRESSBOOK_COLLECTION_KEYS.CONTACTS]
  );
};
